<template>
  <div class="container">
    <div class="body">
      <div class="icon left"></div>
      <div class="index fs32 co_023 font_w">{{Number(index) + 1}}</div>
      <div class="index fs20 co_023">{{title}}</div>
      <div class="icon right"></div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ExportReportTitle',
    components: {},
    props: {
        title: String,
        index: String
    },  
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  height: 70px;
  .body {
    width: 160px;
    display: flex;
    border-bottom: 2px solid #386ccf;
    align-items: flex-end;
    justify-content: space-between;
    .icon {
      border: 1.5px solid #023A9F;
      width: 8px;
      height: 8px;
      margin-bottom: 3px;
    }
  }
}
</style>